import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Constant } from '../../core/constant';

@Injectable({ providedIn: 'root' })
export class UploadFileService {

  url = environment.urlUploadBackEnd + Constant.API_UPLOAD;
  
  static fileExtensions = ['jpeg', 'jpg', 'png', 'gif'];
  constructor(
    private http: HttpClient

  ) { }
  static validate(files: any) {
    // const file = event.target.files[0];
    // check maximum items upload
    let result = true;
    for (let file of files) {
      if (file.size > environment.MAX_FILE_SIZE) {
        result = false;
      }
    }
    return result;
  }
  uploadFile(files, typeValidate?) {
    return new Promise((resolve, reject) => {
      let formData = new FormData();
      if (files.length){
        for (let file of files) {
          formData.append("images", file);
        }
      } else {
        formData.append("images", files);
      }
      return this.http.post(this.url, formData)
      .subscribe((response) => {
          resolve(response);
      },
      (error) => {
        reject(error);
      });
    });

  }

  public uploadDocument(files: File[], url, datas?): Promise<any> {
    let formData = new FormData();
    for (let file of files) {
      formData.append('files', file);
    }
    if (datas) {
      for (let data of datas) {
        formData.append(data.key, data.value);
      }
    }
    return this.http.post(this.url + url, formData).toPromise().then((res: any) => res.json());
  }

}
